import { useEffect, useRef, useState } from "react";
import styled from 'styled-components';
import { FeedbackDetail, FeedbackReason, FeedbackType } from "../types/Feedback"
import { backendProxy } from "../hooks/backendProxy";

const FeedbackFormDiv = styled.div<{ waiting: boolean }>`
    position: absolute;
    cursor: ${props => props.waiting ? "wait" : "default"};
    z-index: 999;
    width: 320px;
    background-color: #f9f9f9;
    color: #000;
    padding: 10px;
    border: 1px solid #ddd;
    border-radius: 5px;
    bottom: 0;
    left: 130px;
    transition: opacity 0.3s;
    box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.2);
    font-size: 12px; line-height: 14px;
    @media (max-width: 768px) {width: 280px;}
    @media (max-width: 480px) {max-width: calc(100% - 25px); bottom: initial; top: 50%; left: 50%; transform: translateX(-50%) translateY(-110%);}
    &::after {
        content: "";
        position: absolute;
        bottom: 18px;
        left: -5px;
        margin-left: -5px;
        border-width: 5px;
        border-style: solid;
        border-color: transparent #000 transparent transparent;
        @media (max-width: 480px) {display: none;}
    }
    label {
        display: block; margin-bottom: 5px; font-weight: bold;
        &.title {font-weight: bold;}
        &.outer-label {padding-top: 5px; margin-bottom: 4px;}
    }
    select {
        width: 100%;
    }
    textarea {
        width: calc(100% - 6px); height: 60px; margin-bottom: 5px; resize: none;
    }
    > select, > div, > textarea {
        margin-bottom: 10px;
    }
    .send-button {
        padding: 6px 12px;
        background-color: #008334;
        color: #fff;
        border: none;
        cursor: pointer;

        &:disabled{
            background-color: #bbb;
            cursor: default;
        }
    }
`

type FeedbackFormProps = {
    type: FeedbackType;
    topic: string;
    onSave: (details: FeedbackDetail) => void;
    onCancel: () => void;
}
export const FeedbackFormNegative: React.FC<FeedbackFormProps> = ({ type, topic, onSave, onCancel }) => {
    const feedbackFormRef = useRef<HTMLDivElement>(null);
    const [availableReasons, setAvailableReasons] = useState<FeedbackReason[]>();
    const [selectedReason, setSelectedReason] = useState<string>();
    const [flopAnswer, setFlopAnswer] = useState<boolean>(false);
    const [emailAddress, setEmailAddress] = useState<string>("");
    const [comment, setComment] = useState<string>();
    const [error, setError] = useState<string>();
    const [saving, setSaving] = useState(false);

    const init = async () => {
        try {
            const data = await backendProxy.loadFeedbackFormData();
            setAvailableReasons(data.reasons.filter(r => r.type === type));
        } catch (ex) {
            setError(`Fehler: ${ex}`)
        }
    }
    useEffect(() => {
        if (!availableReasons) {
            init();
        }
    });

    useEffect(() => {
        const handleOutsideClick = (e: any) => {
            if (feedbackFormRef.current && !feedbackFormRef.current.contains(e.target)) {
                onCancel();
            }
        }
        document.addEventListener("mousedown", handleOutsideClick);
        return () => {
            document.removeEventListener("mousedown", handleOutsideClick);
        };
    });

    const __onSave = () => {
        const detail: FeedbackDetail = { type: type, topic: topic || '', reasonId: selectedReason || '', comment: comment || '', email: emailAddress };
        setSaving(true);
        onSave(detail);
    }

    if (type !== "negative") {
        return null;
    };
    if (error) {
        return <div>{error}</div>;
    }

    const initialized = availableReasons && availableReasons.length > 0;

    return (
        !initialized ?
            <FeedbackFormDiv waiting={true}>
                <label>Bitte warten. Formular wird geladen...</label>
            </FeedbackFormDiv>
            :
            <FeedbackFormDiv ref={feedbackFormRef} waiting={saving}>

                <label className="title">Was war das Problem?</label>
                <select defaultValue="" value={selectedReason} onChange={evt => setSelectedReason(evt.target.value)} >
                    <option></option>
                    {availableReasons.map(reason => <option value={reason.id} key={reason.id}>{reason.text}</option>)}
                </select>
                <label className="outer-label">Thema der Frage:</label>
                <div>{topic}</div>

                <label className="outer-label">Zusätzliches Feedback / Detailangaben:</label>
                <textarea rows={3} value={comment} onChange={evt => setComment(evt.target.value)} />

                <div>
                    <label style={{ float: 'left', marginTop: '2px' }} className="title" onClick={() => setFlopAnswer(!flopAnswer)}>Ist diese Antwort besonders schlecht? (Wettbewerb)</label>
                    <input style={{ float: 'right' }} type="checkbox" checked={flopAnswer} onChange={() => setFlopAnswer(!flopAnswer)}></input>
                </div>
                <div style={{ clear: 'both' }} />
                { flopAnswer &&
                    <p>
                        Diese Antwort ist so schlecht oder absurd, dass sie ausgezeichnet werden sollte. <br/>
                        Falls «Ihre» Antwort gewinnt, gewinnen auch Sie. Als Kontakt benötigen wir dafür Ihre E-Mail-Adresse:
                        <br />
                        <input type="text" style={{ width: 'calc(100% - 15px)' }} value={emailAddress} onChange={evt => setEmailAddress(evt.currentTarget.value)} />
                    </p>
                }
                <input className="send-button" value="Senden" type="button" disabled={saving || !selectedReason || (flopAnswer && !emailAddress)} onClick={__onSave} />

            </FeedbackFormDiv>
    )
}